import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ScoringModal = ({ show, onHide, baseData, onScore }) => {
    const [delivery, setDelivery] = useState({ runs_scored: 0, extra_runs: 0, extra_type: null });

    useEffect(() => {
        if (baseData) {
            setDelivery(baseData);
        }
    }, [baseData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDelivery(prev => ({ ...prev, [name]: parseInt(value) || 0 }));
    };

    const handleSave = () => {
        onScore(delivery);
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton><Modal.Title>Confirm Delivery</Modal.Title></Modal.Header>
            <Modal.Body>
                {delivery.extra_type === 'wide' && <h5>Wide Ball (+{delivery.extra_runs} run)</h5>}
                {delivery.extra_type === 'noball' && <h5>No Ball (+{delivery.extra_runs} run)</h5>}

                <Form.Group className="mb-3">
                    <Form.Label>Runs by Batsman</Form.Label>
                    <Form.Control type="number" name="runs_scored" value={delivery.runs_scored} onChange={handleInputChange} />
                </Form.Group>
                
                {/* This handles the "Wide + 4" scenario */}
                {['wide', 'noball', 'bye', 'legbye'].includes(delivery.extra_type) &&
                    <Form.Group className="mb-3">
                        <Form.Label>Additional Runs (Byes/Overthrows)</Form.Label>
                        <Form.Control type="number" name="extra_runs" value={delivery.extra_runs} onChange={handleInputChange} />
                    </Form.Group>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="primary" onClick={handleSave}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ScoringModal;
